import Head from "next/head";
import Searchbar from "../components/searchbar/searchbar";
import { useRouter } from "next/router";
import PageFooter from "../components/footer/page-footer";
import PageNavbar from "../components/navbar/navbar";
import styles from './app.module.css';
import { NavBarMobile } from "../components/navbar-mobile/navbar-mobile";
import cherryblossomLogoWhite from './../public/CherryLogoWhite.png';
import cherryBlossomLogoPink from './../public/CherryLogoPink.png';
import CartHandler from '../utils/shopping-cart-handler';
import Cart from "../components/cart/cart";
export default function MyApp({ Component, pageProps }: {Component: any, pageProps: any}) {
  const router = useRouter();
  const handleClick = (event: any) => {
    event.stopPropagation();
    router.push('/');
  }
  if (typeof document !== 'undefined') {
    CartHandler.init(document);
  }


  return (
	
	<>
    <Head>
      <title>Cherryblossom.no | Sammenlign priser på skjønnhetsprodukter</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" /> 
      <meta name="tradetracker-site-verification" content="79b69e1bea3be94c1a7780575bfe26d19168142b" />
      <meta name="description" content="Sammenlign priser på kosmetikk, hårpleie, hudpleie og skjeggpleie fra norske nettbutikker. Finn produktet du ønsker til best pris." />
      <meta property="og:title" content="Cherryblossom.no | Sammenlign priser på skjønnhetsprodukter" key="og-title" />
      <meta property="og:description" content="Sammenlign priser på kosmetikk og skjønnhetsprodukter fra norske nettbutikker." key="og-description" />
      <link rel="preload" as="style" href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@500;600&display=swap" />
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@500;600&display=swap" rel="stylesheet" />
      <meta property="og:type" content="website" key="og-type" />
      <meta property="og:site_name" content="Cherryblossom.no" />
      <meta property="og:locale" content="nb_NO" />
      <meta property="og:image" content="https://cherryblossom.no/web-app-manifest-512x512.png" key="og-image" />
      <meta property="og:image:alt" content="Cherryblossom.no" key="og-image-alt" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Cherryblossom.no | Sammenlign priser på skjønnhetsprodukter" key="twitter-title" />
      <meta name="twitter:description" content="Sammenlign priser på kosmetikk og skjønnhetsprodukter fra norske nettbutikker." key="twitter-description" />
      <meta name="twitter:image" content="https://cherryblossom.no/web-app-manifest-512x512.png" key="twitter-image" />
      <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
      <link rel="icon" type="image/png" href={cherryBlossomLogoPink.src} />
      <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
      <link rel="shortcut icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="index" href="https://cherryblossom.no" />
      <script type="application/ld+json" dangerouslySetInnerHTML={
      {__html: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            "@id": "https://cherryblossom.no/#organization",
            name: "Cherryblossom.no",
            url: "https://cherryblossom.no/",
            logo: "https://cherryblossom.no/web-app-manifest-512x512.png",
            email: "post@cherryblossom.no"
          },
          {
            "@type": "WebSite",
            "@id": "https://cherryblossom.no/#website",
            url: "https://cherryblossom.no/",
            name: "Cherryblossom.no",
            inLanguage: "nb-NO",
            publisher: { "@id": "https://cherryblossom.no/#organization" },
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: "https://cherryblossom.no/sok?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          }
        ]
      }).replace(/</g, "\\u003c")}} />
    </Head>
    <div className={styles.headerWrapper}> 
      <header className={styles.header}>
          <div className={styles.headerInner}>
            <img src={cherryblossomLogoWhite.src} alt="Cherryblossom logo" style={{height: '24px'}} />
            <div style={{lineHeight: '18px', marginLeft: '8px', width: '100%'}} onClick={handleClick}>
              <span style={{fontSize: '18px', fontWeight: 600}}>Cherryblossom.no</span><br/>
              <span style={{fontSize: '14px', fontStyle: 'italic'}}>- Dine favoritter samlet på en plass.</span>
            </div>
            <div className="showInMobile showOnPad" style={{overflow: 'visible'}}><Cart /></div>
          </div>
        <PageNavbar/>
        <span className="hideInMobile hideOnPad"><Cart /></span>
      </header>
    </div>      
    <section className={styles.searchBarWrapper}>
        <Searchbar/>
    </section>
    <div className={router.pathname.toLowerCase().indexOf('sok') == -1 ? styles.mainWrapper : ''}>
      <Component {...pageProps} />
    </div>
    <NavBarMobile/>
    <PageFooter/> 
      <style jsx global>{`
        :root {
          --primary-color: #f7f3f0;
          --text-color: #2b2023;
          --secondary-color: #8e2948;
          --tertiary-color: #b33b61;
          --surface-color: #ffffff;
          --muted-color: #71666a;
          --border-color: #e7dedb;
          --shadow-sm: 0 1px 2px rgba(43, 32, 35, 0.05), 0 8px 24px rgba(43, 32, 35, 0.05);
          --shadow-md: 0 18px 44px rgba(69, 38, 48, 0.12);
        }
        html,
        body {
		      padding: 0;
		      margin: 0;
		      font-size: 16px;
          background: var(--primary-color);
          font-family: 'DM Sans', sans-serif;
          color: var(--text-color);
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;   
          scroll-behavior: smooth;       
        }
        h1, h2, h3, h4, h5, h6 {
          color: var(--text-color);
          font-family: 'Playfair Display', serif;
          font-weight: 600;
          line-height: 1.15;
        }
        h1 {
          font-size: clamp(2rem, 4vw, 3.25rem);
        }
        h2 {
          font-size: clamp(1.65rem, 3vw, 2.25rem);
        }          
        a {
          color: var(--text-color);
          text-underline-offset: 3px;
        }
        a:visited{
          color: var(--text-color);
        }           
        .pinkHeader {
          
          color: var(--text-color);
          padding: 8px;
        }
        #__next {
          height: inherit;
        }
        * {
          box-sizing: border-box;
        }
        button, input, select {
          font: inherit;
        }
        button, a, input, select {
          transition: background-color .2s ease, border-color .2s ease, color .2s ease, box-shadow .2s ease, transform .2s ease;
        }
        :focus-visible {
          outline: 3px solid rgba(179, 59, 97, .35);
          outline-offset: 3px;
        }
        .showOnPad {
          display: none;
        }
        .hideInMobile {
          display: block;
        }
        .showInMobile {
          display: none;
        }   
        @media only screen and (max-width: 600px) {
          .hideInMobile {
            display: none;
          }
          .showInMobile {
            display: block;
            overflow: hidden;
            text-align: center;
          }            
        }
        @media only screen and (min-width: 600px) and (max-width: 1200px) {
          .hideOnPad {
            display: none;
          }
          .showOnPad {
            display: block;
          }          
        }
        @media (prefers-reduced-motion: reduce) {
          html { scroll-behavior: auto; }
          *, *::before, *::after { transition: none !important; animation: none !important; }
        }
      `}</style>
    </>
  )
}
